'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMMON_MESSAGE = exports.COMMON_MESSAGE = 'COMMON_MESSAGE';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/messageTypes.js
// module id = 247
// module chunks = 2 3